export const styles = (theme) => ({

closeButton:{
    width: "30px",
    height: "30px",
    background: "#242424",
    minWidth: "inherit",
    // position: "absolute",
    right: "0px",
    float:"right",
    "& svg":{
        fontSize: "17px",
    }
},
dataViewContainer:{
    "& .MuiPaper-rounded":{
        background: "#353535", 
    },
    "& > div.MuiPaper-rounded":{
        height:"300px",
    },
    "& .MuiBox-root .MuiPaper-root":{
        height: "calc(100% - 45px) !important",
    },
    "& .popupWindow":{
        height: "220px !important",
    },
    "& .popupData":{
        alignItems:"center",
    }
},
modalPopupWrap:{
    "& .MuiDialog-paper":{
        minWidth:"1000px",
        textAlign:"left",
        maxWidth:"1024px",
    },
    "& .MuiDialogTitle-root": {
        padding: "0px",
    },
},
artistName:{
    fontSize: ".9em",
},
headTag:{
    fontSize: "1.2em",
    fontWeight: "400",
    color: "#fff",
    lineHeight: "1",
    maxWidth:"98%",
    paddingTop:"10px",
},
playerPopContainer:{
    marginTop:"20px",
    "& > div":{
        paddingLeft:"0 !important",
        margin:"0",
        width:"100%",
    },
    "& .duration-container":{
        right: "20px",
        marginTop: "46px",
    },
    "& .popupWave":{
        height:"57px !important",
    },
    "& .MuiSlider-root":{
        marginTop: "0",
        marginLeft: "5px",
        marginRight: "15px",
    }
},
innerPadding:{
    "& .popupProgress ":{
        height: "50px",
        "& .waveImage":{
            filter: "brightness(0) invert(1)",
            width: "100%",
            height: "57px",
            position: "absolute",
            imageRendering: "pixelated !important",
        }
    },
    paddingLeft:"18px",
},
traffiCLights:{
    borderRadius:"50px !important",
    fontSize:"10px",
    width: "20px",
    height: "20px",
    margin: "0 auto",
},
inlineAvatar:{
    display:"flex",
    alignItems: "center",
    fontSize: "14px",
    textTransform: "uppercase",
    fontWeight: "bold",
    margin:" 15px 0 0px 0",
    "& .MuiAvatar-root":{
        margin:"0 10px 0  0",
        color:"#fff !important"
    }
},
modalContentHeader:{
    fontSize:"17px",
    padding:"10px 15px 12px 15px",
    borderBottom:"1px solid #999",
},
textContainer:{
    fontSize:"13px",
    color:"#fff"
},
infoText:{
    padding:"0 0 0 40px",
    "&:before":{
    content:"''",
    display: "inline-block",
    width: "7px",
    height: "7px",
    background: "#fff",
    borderRadius: "50px",
    verticalAlign: "middle",
    marginRight: "10px"
    }
},
singleView:{
    color:"#fff !important",
    width: "20px",
    height: "20px",
},
imgContainer:{
    padding:"10px 20px 20px 0px",
    "& img":{
        boxShadow:"0 0 5px #000", 
    }
}
});